var BreadCrumbModel;

module.exports = BreadCrumbModel = (function() {
  function BreadCrumbModel(arg) {
    this.title = arg.title, this.friendlyName = arg.friendlyName, this.id = arg.id, this.href = arg.href, this.showSeparator = arg.showSeparator, this.showHref = arg.showHref;
    if (this.showHref == null) {
      this.showHref = true;
    }
    if (this.showSeparator == null) {
      this.showSeparator = true;
    }
  }

  BreadCrumbModel.prototype.getTitle = function() {
    var ref;
    return (ref = this.title) != null ? ref : this.friendlyName;
  };

  return BreadCrumbModel;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2JyZWFkY3J1bWIvY29tbW9uL21vZGVscy9jcnVtYi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hZGNhYmFsbGVyby9uYXBpc3RyYW5vL2J1aWxkLzE0OTI0Njc5NzUzNzktMzc5NTIvc3RhZ2luZy0yMDE3LjA0LjE3XzIyLjE1L2dvb2RzL21vZHVsZXMvYnJlYWRjcnVtYi9jb21tb24vbW9kZWxzL2NydW1iLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxPQUFQLEdBQXVCO0VBQ1IseUJBQUMsR0FBRDtJQUFFLElBQUMsQ0FBQSxZQUFBLE9BQU8sSUFBQyxDQUFBLG1CQUFBLGNBQWMsSUFBQyxDQUFBLFNBQUEsSUFBSSxJQUFDLENBQUEsV0FBQSxNQUFNLElBQUMsQ0FBQSxvQkFBQSxlQUFlLElBQUMsQ0FBQSxlQUFBOztNQUNqRSxJQUFDLENBQUEsV0FBWTs7O01BQ2IsSUFBQyxDQUFBLGdCQUFpQjs7RUFGUDs7NEJBSWIsUUFBQSxHQUFVLFNBQUE7QUFDUixRQUFBOzhDQUFTLElBQUMsQ0FBQTtFQURGIn0=
